/* file description */
import * as React from 'react';
import { Drawer } from 'antd';
import { Popup } from 'antd-mobile';
import { CloseOutlined } from '@ant-design/icons';
import useMetaStore from '@/store/useMetaStore';

export const DrawerLayout = (props) => {
  const { isMobile } = useMetaStore();

  if (isMobile) {
    return (
      <Popup
        {...props}
        mask
        onMaskClick={props.onClose}
      >
        <div
          style={{ height: '40vh', overflowY: 'scroll', padding: '20px' }}
        >
          {props.children}
        </div>
      </Popup>
    );
  }

  return (
    <Drawer maskClosable={false} {...props} closable={!!props?.title}>
      {
        !props?.title && (
        <div
          style={{ position: 'absolute', right: 0, top: 0, padding: 12, zIndex: 9999, cursor: 'pointer' }}
          onClick={props.onClose}
        >
          <CloseOutlined />
        </div>
        )
      }
      {props.children}
    </Drawer>
  );
};
